import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { httpsCallable } from 'firebase/functions';
import { KeyRound, Mail, CheckCircle2, AlertCircle, ArrowRight } from 'lucide-react';
import { functions } from '../../firebase';
import './establishment.css';

function ActivationPage() {
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const fn = httpsCallable(functions, 'activateEstablishmentAccount');
      await fn({ email: email.trim(), code: code.trim() });
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Code invalide ou expiré.');
    } finally {
      setSubmitting(false);
    }
  };

  if (success) {
    return (
      <div className="est-login-page">
        <div className="est-login-card">
          <div className="est-login-head">
            <div className="est-login-icon"><CheckCircle2 size={28} /></div>
            <h1>Compte activé</h1>
            <p>Tu peux maintenant te connecter à ton Espace Établissement.</p>
          </div>
          <button
            type="button"
            className="est-btn est-btn-primary"
            onClick={() => nav('/etablissement/login', { replace: true })}
            style={{ justifyContent: 'center' }}
          >
            Se connecter <ArrowRight size={16} />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="est-login-page">
      <div className="est-login-card">
        <div className="est-login-head">
          <div className="est-login-icon"><KeyRound size={28} /></div>
          <h1>Activation du compte</h1>
          <p>
            Saisis l'email utilisé lors de ta demande et le code à 6 chiffres qui t'a été
            transmis par l'équipe CrousRadar.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="est-login-form">
          <label className="est-field">
            <span>Email</span>
            <div className="est-input-wrap">
              <Mail size={16} />
              <input
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </label>

          <label className="est-field">
            <span>Code à 6 chiffres</span>
            <div className="est-input-wrap">
              <KeyRound size={16} />
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]{6}"
                maxLength={6}
                required
                value={code}
                onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                style={{ letterSpacing: '0.4em', fontWeight: 800 }}
              />
            </div>
          </label>

          {error && (
            <div className="est-alert est-alert-error">
              <AlertCircle size={16} />
              <span>{error}</span>
            </div>
          )}

          <button
            type="submit"
            className="est-btn est-btn-primary"
            disabled={submitting}
            style={{ justifyContent: 'center' }}
          >
            {submitting ? 'Activation…' : 'Activer mon compte'}
          </button>

          <p className="est-login-footnote">
            Pas encore fait ta demande ?{' '}
            <Link to="/etablissement/demande-acces-partenaire">Déposer une demande</Link>
          </p>
        </form>
      </div>
    </div>
  );
}

export default ActivationPage;
